import IncludePropertyInEvents from "../../../../contents/docs/integrate/feature-flags-code/_snippets/include-feature-flag-property-in-backend-events.mdx";
import RubySetSendFeatureFlagsTrue from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-ruby-set-send-feature-flags-to-true.mdx";
import RubyOverrideServerProperties from "../../../../contents/docs/integrate/feature-flags-code/_snippets/override-server-properties/ruby.mdx";
import * as React from 'react';
export default {
  IncludePropertyInEvents,
  RubySetSendFeatureFlagsTrue,
  RubyOverrideServerProperties,
  React
};